import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EcoGraphicSwiper from 'eco-design/sections/eco-graphic-swiper';
import style from './index.module.scss';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/i18n';
import { useEffect } from 'react';

export default function Comp() {
    const { t } = useLang('theProduct.SectionI');
    const { locale = 'us' } = getLocal();

    const itemsA = [
        {
            isVideo: true,
            pc:
                locale === 'us'
                    ? 'https://websiteoss.ecoflow.com/upload/video/1744874656039/a.mp4'
                    : 'https://websiteoss.ecoflow.com/upload/video/1744874656257/b.mp4',
            title: t('item1_title'),
            desc: t('item1_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1740135394488/%E5%9B%BE%E7%89%87.png',
            title: t('item2_title'),
            desc: t('item2_desc'),
        },
    ];
    useEffect(() => {
        if (typeof window !== 'undefined') {
            const module = document.querySelector('#SectionI') as HTMLDivElement;

            // 监听 module 是否可见并播放
            const observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        const video = document.querySelector('#SectionI .eco-video video') as HTMLVideoElement;
                        const callback = () => video.pause();
                        if (entry.isIntersecting) {
                            if (video) {
                                video.loop = false;
                                video.play();
                                video.currentTime = 0;
                                video?.addEventListener('ended', callback);
                            }
                        } else {
                            video?.removeEventListener('ended', callback);
                        }
                    });
                },
                {
                    threshold: 0.5,
                },
            );
            observer.observe(module);
            return () => {
                observer.disconnect();
            };
        }
    }, []);
    return (
        <div id="SectionI">
            <EcoSpace />
            <EcoSectionCommon className={style.section} label={t('label')} title={t('title')} />
            <EcoSpaceSmall />
            <EcoGraphicSwiper className={style.graphic} uiType="ui4" items={itemsA} />
            <EcoSpace />
        </div>
    );
}
